import hardtack from 'hardtack';
import { useEffect } from 'react';
import { useTranslation } from '@hotjar/translations';
import { useCurrentUser } from './useCurrentUser';

/**
 * copied from /webapp/domains/common/user-data
 */
function getLoggedIn(): boolean {
  return hardtack.get('REF') !== undefined;
}

/**
 * Hook that loads the user locale in i18next just once when loading the app.
 */
export const useUserLocaleSetting = (): void => {
  const { i18n } = useTranslation();
  const { data: currentUser } = useCurrentUser();

  const isLoggedIn = getLoggedIn();

  useEffect(() => {
    if (
      isLoggedIn &&
      Boolean(currentUser?.locale) &&
      Boolean(i18n.resolvedLanguage) &&
      i18n.resolvedLanguage !== currentUser?.locale &&
      !(currentUser?.isDemoUser ?? false)
    ) {
      i18n.changeLanguage(currentUser?.locale);
    }
  }, [currentUser?.isDemoUser, currentUser?.locale, i18n, isLoggedIn]);
};
